module.exports = __webpack_public_path__ + "static/media/Logo_light.119b8b75.svg";